import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { HomeContext } from "../containers/Home";
import useHandleContextMenu from "../hooks/useHandleContextMenu";
import { TOperationData } from "../types/operation";
import { TProjectData } from "../types/project";
import { GetAntIcon } from "../utils/ant_icons";
import AuditLogButton from "./AuditLogButton";
import AuditLogModal from "./Modal/AuditLogModal";

function OperationRelatedButtons({
	project,
	operation,
}: {
	project: TProjectData;
	operation: TOperationData;
}) {
	const navigate = useNavigate();

	const { handleContextMenu } = useHandleContextMenu();
	const { currentTenantKey }: any = useContext(HomeContext);

	const [auditOpen, setAuditOpen] = useState(false);

	return (
		<>
			<div className="panel-main-buttons-container">
				{/* {(hasEditOperationPermission ||
                    hasDeleteOperationPermission) && ( */}
				<a
					onClick={() => {
						navigate(`${operation.operation_code}/operation-settings`, {
							replace: true,
							state: { ...operation },
						});
					}}
					onContextMenu={(e: any) => {
						const location = `${window.location.href}/operation-settings`;
						handleContextMenu(e, { link: location });
					}}
				>
					{GetAntIcon("setting")} Operation settings
				</a>
				{/* )} */}

				<AuditLogButton
					moduleKey="project-delivered"
					handleClick={() => {
						setAuditOpen(true);
					}}
				/>
			</div>
			<AuditLogModal
				tenantKey={currentTenantKey}
				identifierKeys={{
					project_code: project?.project_code,
					operation_code: operation?.operation_code,
				}}
				type={"operation"}
				label={"Well operation "}
				open={auditOpen}
				handleClose={() => {
					setAuditOpen(false);
				}}
			/>
		</>
	);
}

export default OperationRelatedButtons;
